export type TimeRange = {
  startTime: string;
  endTime: string;
};

export const emptyTimeRange: TimeRange = {
  startTime: '',
  endTime: '',
};

const timeFields = {
  startTime: {
    label: 'Start Time',
    type: 'time',
  },
  endTime: {
    label: 'End Time',
    type: 'time',
  },
} as const;

export function TimeRangeFilter({
  onTimeRangeChange,
  timeRange,
}: {
  onTimeRangeChange: (fieldKey: string, value: string) => void;
  timeRange?: TimeRange;
}) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {Object.keys(timeFields).map((fieldKey) => {
        const fieldConfig = timeFields[fieldKey as keyof typeof timeFields];
        return (
          <div className="flex flex-col" key={fieldKey}>
            <label className="text-sm" htmlFor={fieldKey}>
              {fieldConfig.label}
            </label>
            <input
              className="block w-full appearance-none rounded-md bg-transparent text-base text-slate-900 placeholder:text-slate-600 focus:outline-none sm:text-sm sm:leading-6"
              id={fieldKey}
              type={fieldConfig.type}
              onChange={(e) => onTimeRangeChange(fieldKey, e.target.value)}
              value={timeRange?.[fieldKey as keyof TimeRange]}
            />
          </div>
        );
      })}
    </div>
  );
}
